export default __webpack_public_path__ + "static/media/profilepic.0645c91d.jpeg";